import React from 'react'
import * as s from './button.module.css'

interface ButtonProps {
    href?: string,
    content: string,
    onClick?: any,
    outlined?: boolean,
    type: 'link' | 'button' 
}

const Button: React.FC<ButtonProps> = ({ href, content, onClick, type, outlined }) => {

    const className = outlined ?s.outlined : s.contained

    if (type === 'link') {
        return <a href={href} className={className}>
            {content}
        </a>
    }
    else if (type === 'button') {
        return <button className={className} onClick={onClick}>
            {content}
        </button>
    }
    return <></>

}

export {Button}